var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"overlay"},[_c('img',{attrs:{"alt":"loading","src":"/img/wheel.svg","width":"200","height":"200"}})])}]

export { render, staticRenderFns }